/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageQuestion.css';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Questions';
import {connect} from 'react-redux';
import * as actionsProg from '../../Redux/Actions/Programs';
import * as httpService from '../HttpService/HttpService';
import * as PropertyBucket from '../../Properties/Properties.js';
import * as validator from '../Validators/ControlValidator.js';
import {QuestionDto} from '../Dtos/QuestionDto';
import {Waiter} from '.././WaitingSign/Waiting';
import {Link} from 'react-router-dom';
import PopUp from '.././PopUp/PopUp';
import Input from '../Input/Input';
import FieldsetCustom from '../FieldsetCustom/FieldsetCustom';
import RadioCustom from '../RadioCustom/RadioCustom';
import SelectCustom from '../SelectCustom/SelectCustom';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {getUserProgramFromPwd} from "../../Helpers/utils";

class SearchQuestion extends React.Component {

	constructor(props, size) {
		super(props);
		this.editWindow = React.createRef();
		
		this.state = {
			orderById: "",
			orderDirection: "asc",
			pageSize: 10,
			pageNumber: 0,
			filters: [],
			selectedPrograms: [],
			violations: null,
			disabled: false,
			isWaiting: false,
			showEdit: false,
			showEditTab: false,
			showPopUp: false,
			defaultChecked: 'all',
			editedBlockTitle: '',
			classesQuestion: [],
			columns: [
				{title: 'Kod pytania', field: 'abbrev', width: 140},
				{title: 'Pytanie', field: 'question', minWidth: 240},
				{title: 'Blok', field: 'blockName', width: 240},
				{title: 'Aktywne', field: 'active', width: 120, render: (row) => {
					return row.active ? 'Tak' : 'Nie';
				}}
			],
			filterValues: [],
			userProgram: null
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.changeActivation = this.changeActivation.bind(this);
		this.selectProgRef = React.createRef();
		this.tableRef = React.createRef();
	}

	columnMap = new Map([
		[0, 'abbrev'],
		[1, 'question'],
		[2, 'blockName'],
		[3, 'active']
	]);

	componentDidMount() {
		document.title = "e-Kontrole | Pytania";
		const {fetchQuestionsData, fetchProgsData} = this.props;

		const userRole = localStorage.getItem('userRole');

		if (!userRole) {
			console.error('User role not found in localStorage');
			return;
		}

		const isSuperAdmin = userRole === 'SA';
		const defaultChecked = isSuperAdmin ? 'std' : 'add';

		const userProgram = store.getState().programs?.selected;

		fetchProgsData().then(() => {
			const programs = store.getState().programs?.programs || [];
	
			const program = programs.find(x => x.code.toLowerCase() === userProgram?.code?.toLowerCase());
	
			if (program) {
				this.setValues([program]);
			} else {
				fetchQuestionsData(
					defaultChecked,
					this.state.selectedPrograms,
					() => {},
					this.state.pageSize,
					this.state.pageNumber,
					this.state.filters
				);
			}
		}).catch(error => {
			console.error('Error fetching programs data:', error);
		});

		this.setState(prevState => ({
			...prevState,
			defaultChecked
		}));
	}

	componentDidUpdate() {
		const userProgram = store.getState().programs?.selected;

		if(userProgram && userProgram.code.toLowerCase() !== this.state.userProgram) {
			this.setState({userProgram: userProgram.code.toLowerCase()});
			this.setValues([userProgram]);
		}
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	handleChange = (e) => {
		if(this.tableRef.current){
			this.tableRef.current.dataManager.columns.map(item => {
			  this.tableRef.current.onFilterChange(item.tableData.id, '');
			})
		  }

		const filters = [];

		const selectedPrograms = [];

		const pageSize = 10;
		const pageNumber = 0;

		this.setState({
			defaultChecked: e,
			pageSize: pageSize,
			pageNumber: pageNumber,
			filters,
			selectedPrograms,
			filterValues: []
		});

		this.props.fetchQuestionsData(e, selectedPrograms, () => {
		}, pageSize, pageNumber, filters);

	};

	
	setValues = (values) => {

		const valuesChanged = !values.every(val => this.state.filterValues.some(filter => filter.id === val.id)) || values?.length !== this.state.filterValues?.length;

		if(valuesChanged) {
			const selectedPrograms = values.map(program => {
				return {
					id: program.id,
					code: program.code
				}
			});
	
			const pageSize = 10;
			const pageNumber = 0;
	
			this.setState({selectedPrograms, filterValues: values, pageSize: pageSize, pageNumber: pageNumber});
	
			const {fetchQuestionsData} = this.props;
			fetchQuestionsData(this.state.defaultChecked, selectedPrograms, () => {}, pageSize, pageNumber, this.state.filters);
		}

	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type}
		})

	};

	showActionsWindow = () => {
		return (
			<PopUp
				customContent
				handleClosePopup={this.handleCloseQuest}
				title={this.state.showEditTab ? 'Edycja pytania' : null}
			>
				<>{this.state.showEditTab ? this.displayEditTab() : null}</>
			</PopUp>
		)
	};

	showEditTab = () => {
		this.setState({
			showEditTab: true
		});
	};


	displayEditTab = () => {
		let row = this.state.record;
		return (
			<div id='editWindowTab'>
				<Input
					defaultValue={row.abbrev}
					inputId='abbrevEdited'
					label='Kod pytania'
					name='questionAbbrev'
					disabled
				/>
				<Input
					onChange={(e) => this.setState({ editedBlockTitle: e.target.value, violation: null }) }
					textareaNative
					containerClassName={this.state.classesQuestion.join(' ')}
					className='editFields'
					label='Pytanie'
					inputId='questionEdited'
					rows='3'
					defaultValue={row.question}
					name='question'
					maxLength={2000}
					chartsCount={this.state.editedBlockTitle.length}
					errorId='questionNameAlert'
					error={this.state.violations}
					invalid={this.state.violations}
				/>
				<div id='nameAlert' className='red'>  </div>
				<div className='btn_group'>
					<button className='btn save-btn' id='saveNewQuestBtn'
						onClick={() => this.editQuestion(row)}>Zapisz<span className='sr-only'> pytanie</span></button>
					<button className='btn cancel-btn' id='cancelQuestBtn'
						onClick={() => this.closeEditTab()}>Anuluj</button>
				</div>
			</div>
		)
	};

	handleAlertBorder = (validated, className, newClasses, areAllFieldsPassed) => {
		if (validated) {
			let index = newClasses.indexOf('alertBorder');
			areAllFieldsPassed === true ? areAllFieldsPassed = true : null;
			if (index !== -1) {
				newClasses.splice(index, 1);
				this.setState({[className]: newClasses});
			}
		} else {
			areAllFieldsPassed = false;
			if (!newClasses.includes('alertBorder')) {
				newClasses.push('alertBorder');
			}
			this.setState({[className]: newClasses})
		}
		return areAllFieldsPassed;
	};

	editQuestion = (record) => {
		let areAllFieldsPassed = true;
		let question = document.querySelector('#editWindowTab #questionEdited').value;

		let isNameValidated = validator.getMustBeChecked(question, 'nameAlert', PropertyBucket.getQuestionNameMustBeChosen());
		let isNameLongEnough = validator.getMustBeLongEnough(question, 'nameAlert', PropertyBucket.tooLongQuestionTextMessage(2000), 2000);
		areAllFieldsPassed = this.handleAlertBorder(isNameValidated && isNameLongEnough, 'classesQuestion', this.state.classesQuestion, areAllFieldsPassed);

		let _this = this;
		if (areAllFieldsPassed) {
			this.isWaitingOnOff(true);
			let questionId = record.id;
			let url = PropertyBucket.urlEditQuestion(questionId);
			let questionDto = new QuestionDto();
			questionDto.questionId = questionId;
			questionDto.question = question;
			let callPromise = httpService.getServiceWithSupportErrors(url, 'PUT', questionDto);


			callPromise.then(
				function (message) {
					if (message.violations) {
						_this.setState({
							violations: (message.violations.length > 0 ? message.violations?.map(v => {
								return v.violation + '. '
							}) : null),
						});
						_this.isWaitingOnOff(false);
					} else {
						_this.props.fetchQuestionsData(_this.state.defaultChecked, _this.state.selectedPrograms, () => {}, _this.state.pageSize, _this.state.pageNumber, _this.state.filters);
						_this.closeEditTab();
						_this.isWaitingOnOff(false);
						_this.showPopup('Komunikat', PropertyBucket.getCreateQuestionMessage(), 'notify')
					}
				},
				function (error) {
					_this.isWaitingOnOff(false);
					_this.showPopup('Błąd', error, 'error')
				}
			)
		}
	};

	changeActivation = (record) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let questionId = record.id;
		let url = PropertyBucket.urlChangeActivationQuestion(questionId);
		let questionDto = new QuestionDto();
		questionDto.questionId = questionId;
		let messageActive;
		if (record.active === true) {
			questionDto.active = false;
			messageActive = PropertyBucket.getDeactivateQuestionMessage();
		} else {
			questionDto.active = true;
			messageActive = PropertyBucket.getActivateQuestionMessage();
		}


		let callPromise = httpService.getServicePromise(url, 'PUT', questionDto);


		callPromise.then(
			function (message) {
				_this.props.fetchQuestionsData(_this.state.defaultChecked, _this.state.selectedPrograms, () => {}, _this.state.pageSize, _this.state.pageNumber, _this.state.filters);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', messageActive, 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	closeEditTab = () => {
		this.setState({
			showEditTab: false,
			showEdit: false,
		});
	};

	handleCloseQuest = () => {
		this.setState({showEdit: false});
	};

	onEditButtonClick = (row) => {
		this.setState({
			showEdit: true,
			record: row,
			editedBlockTitle: row.question
		});
		this.showEditTab();
	};

	onDeactivateButtonClick = (row) => {
		this.setState({
			showPopup: true,
			record: row,
			popUp: {
				title: 'Zmiana statusu',
				notification: row.active === true ? 'Czy chcesz dezaktywować pytanie ' + row.abbrev + '?' : 'Czy chcesz aktywować pytanie ' + row.abbrev + '?',
				type: 'confirm',
				onClickEvent: () => {
					this.changeActivation(this.state.record)
				}
			}
		})
	};

	getBlockName = (item) => {
		if (item.block && item.block !== null) {
			item.blockName = item.block.name
		}
		return item;
	};

	prepareQuestionData = (data) => {
		if(!data) {
			return [];
		}
		
		let newData = data.map(this.getBlockName);
		return newData;
	};

	isDisabledAction = (data, userRole) => {

		if( userRole === 'SA' ){
			return (data.abbrev.includes('UP.')) && !data.additional ? false : true
		} else if ( userRole === 'A' ) {
			let userCode = '';
			if (store.getState().programs.selected) {
				userCode = store.getState().programs.selected.code;
			} else {
				userCode = getUserProgramFromPwd(store.getState().userData);
			}

			const po = userCode.split('.')[0] + '.';

			return (data.abbrev.includes(po)) && data.additional ? false : true
		} else {
			return true;
		}
	};

	handleFilterChange = (filter) => {
		const keyValuePairs = filter.map(f => Object.values(f));
	
		const filters = keyValuePairs
		  .filter(([property, value]) => property && value !== undefined && value !== '')
		  .map(([property, value]) => ({
			property: property,
			value,
			condition: "Contains",
		  }));

		const pageSize = 10;
		const pageNumber = 0;

		this.setState({...this.state, filters, pageSize, pageNumber});
		  
		const { fetchQuestionsData } = this.props;
		fetchQuestionsData(
		  this.state.defaultChecked,
		  this.state.selectedPrograms,
		  () => {},
		  pageSize,
		  pageNumber,
		  filters,
		  0
		);
	  };

	render() {
		let userRole = localStorage.getItem('userRole');
		let loadedProgsData = store.getState().programs.programs;
		let loadedQuestionsData = store.getState().questions.questions;
		const questions = this.prepareQuestionData(loadedQuestionsData.questions);
		let dropdown;
		let popUp;
		let table;
		if (this.props.questions.isError === true) {
			this.isWaitingOnOff(false);
			this.showPopup('Błąd', this.props.questions.error, 'error')
		}
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
							closePopUp={this.handleClosePopUp}
							highPriority
			/>) : null;
		let editPopup;
		let actions;
		actions = [
			rowData => ({
				icon: 'editButton',
				iconProps: {style: {color: this.isDisabledAction(rowData, userRole) ? '#ccc' : '#0d47a1'}},
				disabled: this.isDisabledAction(rowData, userRole),
				tooltip: <span>Edytuj pytanie<span className='sr-only'> {rowData.question || ''}</span></span>,
				onClick: (event, rowData) => {
					this.onEditButtonClick(rowData);
				}
			}),
			rowData => ({
				icon: 'autorenew',
				iconProps: {style: {color: this.isDisabledAction(rowData, userRole) ? '#ccc' : '#0d47a1'}},
				disabled: this.isDisabledAction(rowData, userRole),
				tooltip: <span>Zmień status<span className='sr-only'> pytania: {rowData.question || ''}</span></span>,
				onClick: (event, rowData) => {
					this.onDeactivateButtonClick(rowData);
				}
			})
		];

		if (loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					values={this.state.filterValues ?? []}
					disabled={store.getState().programs.isLoading || store.getState().questions.isLoading}
					label='Programy'
					id='programsSelectId'
					dropdownId='programmsDropdownId'
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					parentRef={this.selectProgRef}
				/>
			</div>
		}

		if (!store.getState().questions.isLoading) {
			table = <TableCustomLazyLoading
					actions={actions}
					initialPage={0}
					verticalAlign="baseline"
					columns={this.state.columns}
					data={questions}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={loadedQuestionsData.totalElements}
					page={this.state.pageNumber}
					pageSize={this.state.pageSize}
					tableRef={this.tableRef}
					onChangePage={(page, size) => {
						this.setState({ ...this.state, pageSize: size, pageNumber: page });
						const { fetchQuestionsData } = this.props;
						fetchQuestionsData(this.state.defaultChecked, this.state.selectedPrograms, () => {}, size, page, this.state.filters);
					}}
					onFilterChange={this.handleFilterChange}
					onOrderChange={(column, order) => {
						this.setState({...this.state, orderById: column, orderDirection: order});

						const { fetchQuestionsData } = this.props;

						fetchQuestionsData(this.state.defaultChecked, this.state.selectedPrograms, () => {}, this.state.pageSize, this.state.pageNumber, this.state.filters, {index: this.columnMap.get(column), direction: order});
					}}
					onChangeRowsPerPage={(pageSize) => {
						this.setState({ ...this.state, pageSize: pageSize });

						const { fetchQuestionsData } = this.props;

						fetchQuestionsData(this.state.defaultChecked, this.state.selectedPrograms, () => {}, pageSize, this.state.pageNumber, this.state.filters);
					}}
				/>
		}

		return (
			<div id='question_search'>
				{popUp}
				{this.state.showEdit ? this.showActionsWindow() : null}
				<div id='add_question'>
					<h2 className='mb-4 float-left'>Pytania</h2>
					<Link to='/create_question' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
					                                                                                aria-hidden='true'
					                                                                                className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ PYTANIE</span></Link>
					<div className='clearfix'/>
				</div>
				<FieldsetCustom
					legend='Wyszukaj pytania'
					row
				>
					<RadioCustom
						label='Wszystkie'
						aria-label={`Pytania wszystkie${this.state.defaultChecked === 'all' ? ' tabela dynamicznie wyświetla wszystkie pytania' : ''}`}
						id='questionsAll'
						value='all'
						checked={this.state.defaultChecked === 'all'}
						onChange={(e) => this.handleChange(e.target.value)}
						name='questionsRadio'
						disabled={store.getState().programs.isLoading || store.getState().questions.isLoading}
					/>
					<RadioCustom
						label='Stałe'
						aria-label={`Pytania stałe${this.state.defaultChecked === 'std' ? ' tabela dynamicznie wyświetla stałe pytania' : ''}`}
						id='questionsStd'
						value='std'
						onChange={(e) => this.handleChange(e.target.value)}
						checked={this.state.defaultChecked === 'std'}
						name='questionsRadio'
						disabled={store.getState().programs.isLoading || store.getState().questions.isLoading}
					/>
					<RadioCustom
						label='Dodatkowe'
						aria-label={`Pytania dodatkowe${this.state.defaultChecked === 'add' ? ' tabela dynamicznie wyświetla dodatkowe pytania' : ''}`}
						id='questionsAdd'
						value='add'
						onChange={(e) => this.handleChange(e.target.value)}
						checked={this.state.defaultChecked === 'add'}
						name='questionsRadio'
						disabled={store.getState().programs.isLoading || store.getState().questions.isLoading}
					/>
				</FieldsetCustom>
				{dropdown}
				<div id='questions_table'>
					{table}
					{editPopup}
				</div>
				<div id='waiter'><Waiter
					loading={this.state.isWaiting || this.props.questions.isLoading || this.props.programs.isLoading}/></div>
			</div>

		)
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProgsData: () => dispatch(actionsProg.getProgramsData()),
		fetchQuestionsData: (qtype, selectedPrograms, callback, pageSize, pageNumber, filters = [], sorting = {}) => dispatch(actions.getData(qtype, selectedPrograms, callback, pageSize, pageNumber, filters, sorting))
	}
};

export const SearchQuestionProvider = connect(mapStateToProps, mapDispatchToProps)(SearchQuestion);





